import axios from "axios";

export const fetchMedicineByCategory = async (categoryId) => {
  if (!categoryId) throw new Error("Category ID is required");

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}Medicine/GetMedicineByCategory?Id=${categoryId}`
    );
    return Array.isArray(res.data) ? res.data : res.data?.data || [];
  } catch (error) {
    console.error("Error fetching medicines:", error);
    throw error;
  }
};
